/* export const rules = [
    { 
        name: 'High-Value Cash Deposit', 
        description: 'Triggers on cash deposits > $10,000.', 
        status: 'Active', 
        version: '1.3',
        environment: 'Production',
        autoCreateCase: true,
        autoAssignTo: 'Retail Banking',
        autoEscalate: false, // New Field
        riskScore: 70,
        logic: { type: 'transaction', field: 'amount', operator: '>', value: 10000, txnType: 'Cash Deposit' }
    },
    { 
        name: 'Transaction to High-Risk Country', 
        description: 'Flags any transaction involving a counterparty in a high-risk jurisdiction.', 
        status: 'Active', 
        version: '1.1',
        environment: 'Production',
        autoCreateCase: false,
        autoEscalate: true, // New Field
        riskScore: 50,
        logic: { type: 'transaction', field: 'counterpartyCountry' }
    },
    { 
        name: 'Activity from Sanctioned Customer', 
        description: 'Flags any activity from a customer with a specific watchlist tag.', 
        status: 'Active', 
        version: '2.0',
        environment: 'Production',
        autoCreateCase: true,
        autoAssignTo: 'Compliance',
        autoEscalate: true, // New Field
        riskScore: 95,
        logic: { type: 'kyc', field: 'watchlistTag', operator: '===', value: 'Sanctions Match' }
    },
    { 
        name: 'Activity from Tagged Customer', 
        description: 'Flags activity from customers with a specific user-defined tag.', 
        status: 'Active', 
        version: '1.0',
        environment: 'Sandbox',
        autoCreateCase: false,
        autoEscalate: false, // New Field
        riskScore: 40,
        logic: { type: 'kyc', field: 'tags', operator: 'contains', value: 'High-Risk-Industry' }
    },
];   */

export const rules = [
    { name: 'High-Value Cash Deposit (KSA/UAE)', description: 'Triggers on cash deposits > SAR/AED 37,500.', environment: 'Production', autoCreateCase: true, autoAssignTo: 'Retail Banking', autoEscalate: false, riskScore: 70, logic: { type: 'transaction', field: 'amount', operator: '>', value: 37500, txnType: 'Cash Deposit' } },
    { name: 'Activity from Sanctioned Customer', description: 'Flags any activity from a customer with a specific watchlist tag.', environment: 'Production', autoCreateCase: true, autoAssignTo: 'Compliance', autoEscalate: true, riskScore: 95, logic: { type: 'kyc', field: 'watchlistTag', operator: '===', value: 'Sanctions Match' } },
    { name: 'Transaction to High-Risk Jurisdiction', description: 'Flags any transaction involving a counterparty in a high-risk jurisdiction.', environment: 'Production', autoCreateCase: false, riskScore: 50, logic: { type: 'transaction', field: 'counterpartyCountry' } },
    { name: 'Rapid Movement of Funds', description: 'Triggers when a large deposit is followed by a rapid withdrawal.', environment: 'Production', autoCreateCase: false, riskScore: 65, logic: { type: 'behavioral', name: 'velocity' } },
    { name: 'High-Risk Occupation Activity', description: 'Flags any transaction over 20,000 from a high-risk occupation.', environment: 'Production', autoCreateCase: false, riskScore: 40, logic: { type: 'kyc', field: 'riskRating', operator: '===', value: 'High' } },
    { name: 'Structuring - Below Threshold', description: 'Triggers on deposits between 35,000 and 37,499.', environment: 'Sandbox', autoCreateCase: false, riskScore: 60, logic: { type: 'transaction', field: 'amount', operator: 'range', min: 35000, max: 37499, txnType: 'Cash Deposit' } },
    { name: 'Expat Transaction Velocity', description: 'Flags high-frequency transactions from customers tagged as Expats.', environment: 'Sandbox', autoCreateCase: false, riskScore: 40, logic: { type: 'kyc', field: 'tags', operator: 'contains', value: 'Expat' } },
    { name: 'Dormant Account Activation', description: 'Flags activity on an account dormant for over 180 days.', environment: 'Sandbox', autoCreateCase: false, riskScore: 55, logic: { type: 'behavioral', name: 'dormancy' } },
    { name: 'Unusual Cross-Border Patterns', description: 'Flags multiple small wires to various high-risk countries in a short period.', environment: 'Sandbox', autoCreateCase: false, riskScore: 75, logic: { type: 'behavioral', name: 'cross-border' } },
    { name: 'Keyword Hit in Memo', description: 'Flags transactions with suspicious keywords in the memo line.', environment: 'Sandbox', autoCreateCase: false, riskScore: 30, logic: { type: 'transaction', field: 'memo' } },
].map(r => ({ ...r, version: '1.0', status: 'Active' }));